import React, {Component} from 'react';
import {Delete, Get, Post} from "./request";
import PropTypes from "prop-types";
import {updateType} from "../forms/utils";
import DivTable from "./divTable";
import {faPencilAlt, faTrashAlt} from "@fortawesome/pro-solid-svg-icons";
import MyCard from "./myCard";
import {Button} from "react-bootstrap";

class EditTable extends Component {

    constructor(props) {
        super(props);

        this.state = {
            item: null,
            parameters: props.parameters,
        }
    }

    componentDidUpdate(prevProps: Readonly<P>, prevState: Readonly<S>, snapshot: SS) {
        if (this.props.form !== prevProps.form) this.close();
    }

    async edit(id) {
        let {body} = await Get(`/v1/extranet/student/${this.props.screenID}/${id}`);

        this.setState({
            item: body
        });
    }

    async save(data) {
        data[this.state.item.IDPropertyName] = this.state.item[this.state.item.IDPropertyName];
        updateType(this.state.item, data);

        await Post(`/v1/extranet/student/${this.props.screenID}`, data, "Sauvegarde en cours..", {render: "Sauvegarde réussie !"}, {render: "Erreur lors de la sauvegarde"});

        this.close(true);
    }

    async delete(id) {
        await Delete(`/v1/delete/${id}/${this.props.screenID}`);

        this.close(true);
    }

    close(withReload = false) {
        this.setState({
            item: null
        });

        if (withReload && this.props.reload) this.props.reload();
    }

    renderForm() {
        return (
            this.state.item &&
            <section className={"mt-5"}>
                <MyCard header={"Détails"}
                        onClose={this.close.bind(this)}
                        body={
                            React.createElement(this.props.form, {save: this.save.bind(this), ...this.state})
                        }/>
            </section>

        );
    }

    renderAddBtn() {
        return (
            <div className={"mt-5 text-right"}>
                <Button variant={"outline-primary"}
                        onClick={() => this.edit(-1)}
                        size="lg">
                    Ajouter
                </Button>
            </div>
        );
    }

    render() {
        return (
            <>
                <DivTable columns={this.props.columns}
                          array={this.props.table}
                          actions={[{
                              onClick: id => this.edit(id),
                              icon: faPencilAlt, title: "Editer"
                          }, {
                              onClick: id => this.delete(id),
                              icon: faTrashAlt, title: "Supprimer"
                          }]}/>
                {this.renderAddBtn()}
                {this.renderForm()}
            </>
        );
    }
}

EditTable.propTypes = {
    parameters: PropTypes.array,
    reload: PropTypes.func,
    screenID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    columns: PropTypes.object.isRequired,
    table: PropTypes.array.isRequired,
    form: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]).isRequired
}

export default EditTable;